import $ from 'jquery';

let promoCount = 0;
let promosToCheck = $('.promos-img-url').length;

if (promosToCheck) {
  $('.promos-img-url-mobile').each(function () {
    const url = $(this).data('img');
    const model = $(this).data('model');
    let mobileImage = new Image();

    mobileImage.onload = function () {
      $(`.promo-${model}`)
        .find('.promo-mobile-image')
        .removeClass('hidden')
        .addClass('block sm:hidden');
    };

    mobileImage.onerror = function () {
      $(`.promo-${model}`).find('.promo-mobile-image').remove();
      $(`.promo-${model}`).find('.promo-desktop-image').removeClass('hidden');
    };

    mobileImage.src = url;
  });

  $('.promos-img-url').each(function (index) {
    const url = $(this).data('img');
    const model = $(this).data('model');
    let image = new Image();

    image.onload = function () {
      promoCount = ++promoCount;
      $(`.promo-${model}`).removeClass('hidden');
      $('.promos-scene').remove();
    };

    image.onerror = function () {
      $(`.promo-${model}`).remove();
    };

    image.src = url;
  });
} else {
  $('.promos-scene').remove();
  $('.no-promos-card').removeClass('hidden');
}
